var _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgWarning2 = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/warning-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/warning-2_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "warning-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 11.459C9.65833 11.459 9.375 11.1757 9.375 10.834V6.45898C9.375 6.11732 9.65833 5.83398 10 5.83398C10.3417 5.83398 10.625 6.11732 10.625 6.45898V10.834C10.625 11.1757 10.3417 11.459 10 11.459Z",
    fill: "#455CC7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.99984 14.375C9.77484 14.375 9.56649 14.2917 9.40815 14.1334C9.33315 14.05 9.27484 13.9584 9.22484 13.8584C9.18318 13.7584 9.1665 13.65 9.1665 13.5417C9.1665 13.325 9.25815 13.1083 9.40815 12.95C9.71649 12.6417 10.2832 12.6417 10.5915 12.95C10.7415 13.1083 10.8332 13.325 10.8332 13.5417C10.8332 13.65 10.8082 13.7584 10.7665 13.8584C10.7248 13.9584 10.6665 14.05 10.5915 14.1334C10.4332 14.2917 10.2248 14.375 9.99984 14.375Z",
    fill: "#455CC7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.0003 18.9579C9.44198 18.9579 8.8753 18.8162 8.3753 18.5246L3.4253 15.6662C2.4253 15.0829 1.80029 14.0079 1.80029 12.8496V7.14961C1.80029 5.99127 2.4253 4.91627 3.4253 4.33294L8.3753 1.47461C9.3753 0.891276 10.617 0.891276 11.6253 1.47461L16.5753 4.33294C17.5753 4.91627 18.2003 5.99127 18.2003 7.14961V12.8496C18.2003 14.0079 17.5753 15.0829 16.5753 15.6662L11.6253 18.5246C11.1253 18.8162 10.5586 18.9579 10.0003 18.9579ZM10.0003 2.29126C9.65865 2.29126 9.30864 2.38293 9.0003 2.55793L4.0503 5.41626C3.43364 5.77459 3.05029 6.43294 3.05029 7.14961V12.8496C3.05029 13.5579 3.43364 14.2246 4.0503 14.5829L9.0003 17.4413C9.61697 17.7996 10.3836 17.7996 10.992 17.4413L15.942 14.5829C16.5587 14.2246 16.942 13.5662 16.942 12.8496V7.14961C16.942 6.44127 16.5587 5.77459 15.942 5.41626L10.992 2.55793C10.692 2.38293 10.342 2.29126 10.0003 2.29126Z",
    fill: "#455CC7"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWarning2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/warning-2.9320e13f.svg";
export { ForwardRef as ReactComponent };